'use strict';
import cloneDeep from 'lodash/cloneDeep';
import has from 'lodash/has';
import isEqual from 'lodash/isEqual';
import isFunction from 'lodash/isFunction';
import {FilterDialogController} from './FilterDialogController';

/**
 * @typedef {Object} FilterModalOptionsConfig
 * @property {String} filterTemplate - The angular template for the filter modal
 * @property {String|Function|Array|FilterDialogController} [controller] - The angular controller for the filter modal
 * @property {isDefaultFilterOptions} [isDefaultFilterOptions]
 * @property {Object} filterOptions - The default filter options
 * @property {Object} sortOptions - The default sort options
 */

/**
 * @callback isDefaultFilterOptions
 * @param {Object} filterOptions
 * @return {Boolean}
 */

export class FilterModalOptions {

  /**
   * @param {FilterModalOptionsConfig} config
   */
  constructor(config) {
    this.animation = 'slide-in-right';
    this.controller = has(config, 'controller') ? config.controller : FilterDialogController;
    this.template = config.filterTemplate;

    this.defaultFilterOptions = cloneDeep(config.filterOptions);
    this.defaultSortOptions = cloneDeep(config.sortOptions);
    this.isDefaultFilterOptions = isFunction(config.isDefaultFilterOptions)
      ? config.isDefaultFilterOptions
      : options => isEqual(this.defaultFilterOptions, options);
  }

  /**
   * @param {Object} filterOptions
   * @param {Object} sortOptions
   * @return {Object}
   */
  getOptions(filterOptions, sortOptions) {
    return {
      animation: this.animation,
      controller: this.controller,
      template: this.template,
      isDefaultFilterOptions: this.isDefaultFilterOptions,
      locals: {
        defaultFilterOptions: this.defaultFilterOptions,
        defaultSortOptions: this.defaultSortOptions,
        filterOptions: filterOptions,
        sortOptions: sortOptions
      },
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/filters/FilterModalOptions.js